import list from './country-list';

export default (key, countryArray = list) => {
  if (!key || !countryArray || !Array.isArray(countryArray)) {
    return {};
  }

  return countryArray.filter((element) => element.country_code === key)[0] || {};
};
